(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var body = document.body, root = body.dataset.root || '/', cur = body.dataset.currency || 'USD';
  var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 });
  var money = function (c) { return fmt.format(c / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var scrim = $('[data-scrim]');

  /* drawers */
  function openD(n) { closeD(); var d = $('#drawer-' + n); if (!d) return; d.classList.add('is-open'); scrim.classList.add('is-on'); body.classList.add('lock'); if (n === 'search') setTimeout(function () { var i = $('input[type=search]', d); if (i) i.focus(); }, 200); }
  function closeD() { $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); }); if (scrim) scrim.classList.remove('is-on'); body.classList.remove('lock'); }

  /* cart */
  var drawerCart = $('#drawer-cart'), free = drawerCart ? Number(drawerCart.dataset.free) || 0 : 0;
  function render(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    var b = $('[data-cart-body]'), f = $('[data-cart-foot]');
    if (!b) return;
    if (!c.item_count) { b.innerHTML = '<p class="muted">Your bag is empty</p><a class="btn" href="' + root + 'collections/all">Keep shopping</a>'; f.hidden = true; return; }
    var bar = '';
    if (free > 0) {
      var left = free - c.total_price, pct = Math.min(100, Math.round(c.total_price / free * 100));
      bar = '<div class="fsb' + (left > 0 ? '' : ' is-done') + '"><p>' + (left > 0 ? 'Add <strong>' + money(left) + '</strong> more to get <strong>free shipping</strong>' : 'You have unlocked <strong>free shipping</strong>') + '</p><div class="fsb__bar"><i style="width:' + pct + '%"></i></div></div>';
    }
    b.innerHTML = bar + c.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      return '<div class="cl"><a class="cl__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="cl__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (it.product_has_only_default_variant ? '' : '<p class="muted small">' + esc(it.variant_title) + '</p>') +
        '<div class="qtyrow"><button data-qty="' + (it.quantity - 1) + '" data-line="' + (i + 1) + '" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button data-qty="' + (it.quantity + 1) + '" data-line="' + (i + 1) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="cl__p">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    $('[data-cart-total]').textContent = money(c.total_price);
    f.hidden = false;
  }
  function getCart() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function post(path, data) { return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }).then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); }); }
  function add(id, btn, qty) {
    var old = btn && btn.textContent;
    if (btn) btn.disabled = true;
    return post('cart/add.js', { items: [{ id: Number(id), quantity: Number(qty) || 1 }] }).then(getCart).then(function () { resetQuick(); openD('cart'); })
      .catch(function () { if (btn && !btn.classList.contains('qcircle')) btn.textContent = 'Unavailable'; })
      .then(function () { if (btn) { btn.disabled = false; if (old && btn.textContent === 'Unavailable') setTimeout(function () { btn.textContent = old; }, 1500); } });
  }

  /* quick add (reference style: Add to bag -> sizes) */
  function resetQuick(except) { $$('[data-quick]').forEach(function (q) { if (q === except) return; var s = $('.qsizes', q), t = $('[data-quick-toggle]', q); if (s) s.hidden = true; if (t) t.setAttribute('aria-expanded', 'false'); }); }

  /* modal + lightbox */
  var lb, lbList = [], lbI = 0;
  function lbShow() { lb.img.src = lbList[lbI]; }
  function lightbox(list, i) {
    if (!lb) {
      var el = document.createElement('div'); el.className = 'lb';
      el.innerHTML = '<button class="lb__x" aria-label="Close">&times;</button><button class="lb__p" aria-label="Previous">&lsaquo;</button><img alt=""><button class="lb__n" aria-label="Next">&rsaquo;</button>';
      document.body.appendChild(el); lb = { el: el, img: $('img', el) };
      el.addEventListener('click', function (e) {
        if (e.target.closest('.lb__p')) { lbI = (lbI - 1 + lbList.length) % lbList.length; lbShow(); }
        else if (e.target.closest('.lb__n')) { lbI = (lbI + 1) % lbList.length; lbShow(); }
        else if (!e.target.matches('img')) el.classList.remove('on');
      });
    }
    lbList = list; lbI = i; lbShow(); lb.el.classList.add('on');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeD(); $$('.modal.on').forEach(function (m) { m.classList.remove('on'); }); if (lb) lb.el.classList.remove('on'); }
    if (lb && lb.el.classList.contains('on')) { if (e.key === 'ArrowRight') { lbI = (lbI + 1) % lbList.length; lbShow(); } if (e.key === 'ArrowLeft') { lbI = (lbI - 1 + lbList.length) % lbList.length; lbShow(); } }
  });

  /* global clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]');
    if (o) { e.preventDefault(); openD(o.dataset.open); return; }
    if (t.closest('[data-close]') || t === scrim) { closeD(); return; }
    var qt = t.closest('[data-quick-toggle]');
    if (qt) { var q = qt.closest('[data-quick]'), qs = $('.qsizes', q), wasOpen = qs.hidden; resetQuick(q); qs.hidden = !wasOpen; qt.setAttribute('aria-expanded', wasOpen ? 'true' : 'false'); return; }
    if (!t.closest('.qsizes')) resetQuick();
    var a = t.closest('[data-add-variant]');
    if (a && !a.disabled) { e.preventDefault(); add(a.dataset.addVariant, a); return; }
    var q2 = t.closest('[data-qty]');
    if (q2) { post('cart/change.js', { line: Number(q2.dataset.line), quantity: Number(q2.dataset.qty) }).then(render); return; }
    var qq = t.closest('[data-q]');
    if (qq) { var inp = $('[data-qty-input]', qq.parentNode); inp.value = Math.max(1, (Number(inp.value) || 1) + Number(qq.dataset.q)); return; }
    var om = t.closest('[data-open-modal]');
    if (om) { var m = $('#modal-' + om.dataset.openModal); if (m) m.classList.add('on'); return; }
    if (t.closest('[data-close-modal]') || t.classList.contains('modal')) { var mm = t.closest('.modal'); if (mm) mm.classList.remove('on'); return; }
    var z = t.closest('[data-zoom]');
    if (z && window.innerWidth > 0) { var g = z.closest('[data-gallery]'), all = $$('[data-zoom]', g); lightbox(all.map(function (x) { return x.dataset.zoom; }), all.indexOf(z)); return; }
  });
  document.addEventListener('submit', function (e) {
    var nf = e.target.closest('[data-notify]');
    if (nf) {
      e.preventDefault();
      var nb = $('button[type=submit]', nf); nb.disabled = true;
      fetch(nf.action, { method: 'POST', body: new FormData(nf), headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
        if (r.url.indexOf('/challenge') > -1) { nf.submit(); return; }
        if (!r.ok) throw new Error('fail');
        $('.notify__row', nf).hidden = true; $('[data-n-ok]', nf).hidden = false;
      }).catch(function () { nb.disabled = false; nf.submit(); });
      return;
    }
    var f = e.target.closest('[data-product-form]');
    if (!f) return;
    e.preventDefault();
    var fd = new FormData(f); add(fd.get('id'), $('[data-add]', f), fd.get('quantity'));
  });
  getCart();

  /* header height (so a bigger logo never breaks the overlap) */
  var hdrEl = $('.header');
  if (hdrEl) { var setHH = function () { document.documentElement.style.setProperty('--hh', hdrEl.offsetHeight + 'px'); }; setHH(); window.addEventListener('resize', setHH); window.addEventListener('load', setHH); document.addEventListener('shopify:section:load', setHH); }

  /* transparent header */
  var hd = $('.header--clear');
  if (hd) { var hf = function () { hd.classList.toggle('is-solid', window.scrollY > 40); }; hf(); window.addEventListener('scroll', hf, { passive: true }); }

  /* hero slider */
  /* A video slide plays all the way through, then the slider moves on. */
  function initHero(h) {
    if (h._hero) return; h._hero = true;
    var track = $('[data-track]', h), slides = $$('.slide', h), dots = $$('.dot', h), i = 0, T = 6000, timer = null, paused = false;
    var pb = $('[data-hero-pause]', h), dn = $('[data-hero-down]', h);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    h.style.setProperty('--hero-t', (T / 1000) + 's');
    function vid(n) { return $('video', slides[n]); }
    function mark() { dots.forEach(function (d, n) { d.classList.toggle('on', n === i); }); slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); }); if (h.classList.contains('is-playing')) { h.classList.remove('is-playing'); void h.offsetWidth; h.classList.add('is-playing'); } }
    function playVideos() {
      slides.forEach(function (s, n) {
        var v = vid(n); if (!v) return;
        if (n === i && !paused) { if (slides.length < 2) v.loop = true; if (v.currentTime > 0 && v.ended) v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); if (n !== i) v.currentTime = 0; }
      });
    }
    function go(n) { i = (n + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); mark(); start(); }
    function stop() { clearTimeout(timer); h.classList.remove('is-playing'); }
    function start() {
      stop(); playVideos();
      if (paused || slides.length < 2 || reduce) return;
      var v = vid(i);
      if (v) {
        // Progress line runs for the video's length; 'ended' moves to the next slide.
        var set = function () { if (v.duration && isFinite(v.duration)) h.style.setProperty('--hero-t', Math.max(1, v.duration - v.currentTime) + 's'); h.classList.add('is-playing'); };
        if (v.readyState >= 1) set(); else v.addEventListener('loadedmetadata', set, { once: true });
        return;
      }
      h.style.setProperty('--hero-t', (T / 1000) + 's');
      h.classList.add('is-playing'); timer = setTimeout(function () { go(i + 1); }, T);
    }
    slides.forEach(function (s, n) { var v = vid(n); if (v) v.addEventListener('ended', function () { if (n === i && slides.length > 1) go(i + 1); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    track.addEventListener('scroll', function () { var k = Math.round(track.scrollLeft / track.clientWidth); if (k !== i) { i = k; mark(); start(); } }, { passive: true });
    if (pb) pb.addEventListener('click', function () { paused = !paused; pb.classList.toggle('is-paused', paused); pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); start(); });
    if (dn) dn.addEventListener('click', function () { var r = h.getBoundingClientRect(); window.scrollTo({ top: window.scrollY + r.bottom, behavior: 'smooth' }); });
    mark(); start();
  }
  $$('[data-hero]').forEach(initHero);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-hero]', e.target).forEach(initHero); });

  /* reviews: arrows move one card at a time (wraps around) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slide-prev],[data-slide-next]'); if (!b) return;
    var row = $('[data-slide-row]', b.closest('[data-slider]')); if (!row || !row.firstElementChild) return;
    var dir = b.hasAttribute('data-slide-next') ? 1 : -1;
    var step = row.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 16);
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4, atStart = row.scrollLeft <= 4;
    var left = dir > 0 && atEnd ? 0 : dir < 0 && atStart ? row.scrollWidth : row.scrollLeft + dir * step;
    row.scrollTo({ left: left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  /* tabs */
  $$('[data-tabs]').forEach(function (t) {
    var tabs = $$('[data-tab]', t), panels = $$('[data-panel]', t);
    tabs.forEach(function (b) { b.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.toggle('on', x === b); });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.tab; });
    }); });
  });

  /* countdown */
  $$('[data-countdown]').forEach(function (c) {
    var target = new Date(c.dataset.countdown).getTime(), nums = $('[data-nums]', c), done = $('[data-donetxt]', c);
    if (isNaN(target)) return;
    function tick() {
      var d = target - Date.now();
      if (d <= 0) { nums.hidden = true; done.hidden = false; done.textContent = c.dataset.done || ''; return false; }
      var p = function (n) { return String(n).padStart(2, '0'); };
      $('[data-d]', c).textContent = p(Math.floor(d / 864e5)); $('[data-h]', c).textContent = p(Math.floor(d % 864e5 / 36e5));
      $('[data-m]', c).textContent = p(Math.floor(d % 36e5 / 6e4)); $('[data-s]', c).textContent = p(Math.floor(d % 6e4 / 1e3));
      return true;
    }
    if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
  });

  /* related products */
  $$('[data-recs]').forEach(function (r) {
    if (r.children.length || !r.dataset.url) return;
    fetch(r.dataset.url).then(function (x) { return x.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t; var n = $('[data-recs]', d);
      if (n && n.innerHTML.trim()) r.innerHTML = n.innerHTML;
    });
  });

  /* gallery counter */
  var gt = $('[data-gallery]'), gc = $('[data-gcount]');
  if (gt && gc) gt.addEventListener('scroll', function () { var n = Math.round(gt.scrollLeft / gt.clientWidth) + 1; gc.textContent = n + ' / ' + gt.children.length; }, { passive: true });

  /* product page */
  var pr = $('[data-product]');
  if (pr) {
    var variants = JSON.parse($('[data-variants]', pr).textContent), idIn = $('[data-variant-id]', pr), price = $('[data-price]', pr),
        save = $('[data-save]', pr), stock = $('[data-stock]', pr), btn = $('[data-add]', pr), low = Number(pr.dataset.low) || 5,
        stickyEl = $('[data-sticky]'), sBtn = $('[data-sticky-add]'), sPrice = $('[data-sticky-price]');
    function paint(v) {
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; if (sBtn) { sBtn.disabled = true; sBtn.textContent = 'Unavailable'; } return; }
      idIn.value = v.id; price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      if (sPrice) sPrice.textContent = v.price;
      if (save) { if (v.c > v.p) { save.hidden = false; save.textContent = 'Save ' + Math.round((v.c - v.p) / v.c * 100) + '%'; } else save.hidden = true; }
      stock.innerHTML = !v.available ? 'Sold out' : (v.stock > 0 && v.stock <= low ? '<span class="stock--low">Only ' + v.stock + ' left</span>' : 'In stock');
      [btn, sBtn].forEach(function (b) { if (b) { b.disabled = !v.available; b.textContent = v.available ? 'Add to bag' : 'Sold out'; } });
      var nw = $('[data-notify-wrap]', pr);
      if (nw) {
        nw.hidden = !!v.available;
        var vt = v.options.join(' / '), pt = $('h1', pr).textContent.trim();
        $('[data-n-variant]', nw).value = vt; $('[data-n-link]', nw).value = location.origin + location.pathname + '?variant=' + v.id;
        $('[data-n-body]', nw).value = 'Back in stock request: ' + pt + ' (' + vt + ')';
      }
      history.replaceState(null, '', '?variant=' + v.id);
    }
    pr.addEventListener('change', function (e) {
      if (!e.target.closest('.opt')) return;
      var chosen = $$('.opt', pr).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      paint(variants.filter(function (x) { return chosen.every(function (c, i) { return x.options[i] === c; }); })[0]);
    });
    if (sBtn) sBtn.addEventListener('click', function () { add(idIn.value, sBtn, $('[data-qty-input]', pr).value); });
    if (stickyEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e = en[0]; stickyEl.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(btn);
    }
  }

  /* instagram carousel: auto slide */
  function initInsta(scope) {
    $$('[data-insta]', scope).forEach(function (sec) {
      if (sec._ig) return; sec._ig = true;
      var track = $('[data-insta-track]', sec);
      if (sec.dataset.auto === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var paused = false, ms = (Number(sec.dataset.speed) || 3) * 1000;
        ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { sec.addEventListener(ev, function () { paused = true; }, { passive: true }); });
        ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { sec.addEventListener(ev, function () { setTimeout(function () { paused = false; }, 1500); }, { passive: true }); });
        setInterval(function () {
          if (paused || document.hidden || !track.firstElementChild) return;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 6, w = track.firstElementChild.getBoundingClientRect().width + gap;
          var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          track.scrollTo({ left: end ? 0 : track.scrollLeft + w, behavior: 'smooth' });
        }, ms);
      }
    });
  }
  initInsta(document);
  document.addEventListener('shopify:section:load', function (e) { initInsta(e.target); });

  /* scroll reveal */
  // With cinematic motion on, motion.js does the reveals (GSAP) instead.
  var io = ('IntersectionObserver' in window && body.classList.contains('anim') && !document.documentElement.classList.contains('motion-ok') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    ? new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.08 }) : null;
  function reveal(scope) {
    if (!io) return;
    $$('.block,.statement,.tiles,.usp,.iwt,.banner,.cd,.mq,.news__in,.insta', scope).forEach(function (el) { if (!el.classList.contains('rv')) { el.classList.add('rv'); io.observe(el); } });
  }
  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
